<div *ngIf="showAlert" class="generic-alert {{styleClass}}" aria-live="assertive">
  <div [ngClass]="title ? 'generic-alert_mt-title' : 'generic-alert_mt-not-title'">
    <i class="generic-alert_icon"></i>
  </div>
  <ng-container *ngIf="href">
    <a class="mr-2" [routerLink]="href">
      <div *ngIf="title" class="pasi-title" [innerHTML]="title | translate"></div>
      <div class="generic-alert_text" [innerHTML]="text | translate"></div>
    </a>
  </ng-container>
  <ng-container *ngIf="clickable">
    <div class="pointer mr-2" (click)="onClickAlert()">
      <div *ngIf="title" class="pasi-title" [innerHTML]="title | translate"></div>
      <div class="generic-alert_text" [innerHTML]="text | translate"></div>
    </div>
  </ng-container>
  <ng-container *ngIf="!href && !clickable">
    <div class="mr-2">
      <div *ngIf="title" class="pasi-title" [innerHTML]="title | translate"></div>
      <div class="generic-alert_text" [innerHTML]="text | translate"></div>
    </div>
  </ng-container>
  <div *ngIf="closable" class="ml-auto" [ngClass]="title ? 'generic-alert_mt-title' : 'generic-alert_mt-not-title'">
    <i class="icosun-close generic-alert_close" (click)="onClickCloseIcon()"></i>
  </div>
</div>
